import React, { useState, useEffect } from "react";
import Header from "../Header/Header";
import Select from "react-select";
import { privateRequest } from "../commonApi/CommonApi";
import Swal from "sweetalert2";
import { Image_URL } from "../commonApi/CommonApi";
import { Helmet } from "react-helmet";
// const BASE_URL = "http://localhost:5500";
// const BASE_URL = "http://52.87.3.228:5500";

function Testimonial() {
  const [selectedFile, setSelectedFile] = useState(null);
  const [imagePreview, setImagePreview] = useState(null);
  const [banner, setBanner] = useState([]);
  const [Heading, setHeading] = useState("");
  const [content, setcontent] = useState("");
  const [selectedStatus, setSelectedStatus] = useState("");
  const [showModal, setShowModal] = useState(false);
  const [selectedItem, setSelectedItem] = useState({});

  const getVideoshort = async () => {
    try {
      const response = await privateRequest.get(
        "/Testimonials/GetTestimonialsByStatus"
      );
      setBanner(response?.data?.data);
    } catch (error) {
      console.error("Error:", error);
    }
  };

  const DeleteVideoShort = async (_id) => {
    try {
      const result = await Swal.fire({
        title: "Are you sure?",
        text: "You will not be able to recover this item!",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#DD6B55",
        confirmButtonText: "Yes, delete it!",
        cancelButtonText: "No, cancel",
        closeOnConfirm: false,
        closeOnCancel: true,
      });

      if (result.isConfirmed) {
        const response = await privateRequest.delete(
          `Testimonials/DeleteTestimonials/${_id}`
        );
        getVideoshort();
        Swal.fire("Deleted!", "Your item has been deleted.", "success");
      } else {
        Swal.fire(
          "Cancelled",
          "Your item deletion has been cancelled.",
          "info"
        );
      }
    } catch (error) {
      console.error("DELETE Error:", error);
      Swal.fire("Error!", "Failed to delete item.", "error");
    }
  };

  const AddVideoShort = async (event) => {
    event.preventDefault();
    try {
      const formData = new FormData();
      formData.append("Image", selectedFile);

      formData.append("name", Heading);
      formData.append("content", content);
      formData.append("Status", selectedStatus);

      let response;
      if (selectedItem._id) {
        response = await privateRequest.put(
          `Testimonials/UpdateTestimonials/${selectedItem._id}`,
          formData
        );
        Swal.fire({
          icon: "success",
          title: "Success!",
          text: "Testimonial updated successfully!",
        });
      } else {
        // Add new item
        response = await privateRequest.post(
          "/Testimonials/AddTestimonials",
          formData
        );
        Swal.fire({
          icon: "success",
          title: "Success!",
          text: "Testimonial added successfully!",
        });
      }

      console.log("POST Response:", response);
      getVideoshort();
      setShowModal(false);

      setSelectedFile(null);

      setImagePreview(null);

      setHeading("");
      setSelectedStatus("");
      setSelectedItem({});
    } catch (error) {
      console.error("Error:", error);
      Swal.fire({
        icon: "error",
        title: "Error!",
        text: error.response.data.message,
      });
    }
  };

  const handleFileInputChange = (event) => {
    const file = event.target.files[0];
    if (file) {
      setSelectedFile(file);
      const reader = new FileReader();
      reader.onloadend = () => {
        setImagePreview(reader.result);
      };
      reader.readAsDataURL(file);
    }
  };
  const resetFileInput = () => {
    // setFile(null);
    setImagePreview(null);

    // Reset the input element's value to an empty string
    const fileInput = document.querySelector('input[type="file"]');
    if (fileInput) {
      fileInput.value = "";
    }
  };

  useEffect(() => {
    getVideoshort();
  }, []);

  return (
    <>
      {banner.length > 0 && (
        <Helmet>
          <script>new DataTable("#my_table");</script>
        </Helmet>
      )}
      <div className="app-main">
        <div className="wrapper">
          <div className="page">
            <div className="page-inner">
              <div className="container-fluid">
                <header className="page-title-bar">
                  <div className="d-flex flex-column flex-md-row">
                    <p className="lead mb-0">
                      <span className="font-weight-bold">Testimonial</span>
                    </p>
                    <button
                      className="btn btn-primary btn-sm ml-auto"
                      onClick={() => {
                        setShowModal(true);

                        setHeading("");
                        setSelectedStatus("");
                        setcontent("");
                        resetFileInput();
                        setImagePreview(null);
                      }}
                    >
                      <i className="fa fa-plus mr-2"></i>Add New
                    </button>
                  </div>
                </header>
                <div className="page-section">
                  <div className="card">
                    <div className="card-body table-responsive">
                      <table
                        id="my_table"
                        className="table table-striped table-hover table-sm no-footer text-center"
                      >
                        <thead className="bg-primary text-white">
                          <tr>
                            <th scope="col">Sr No</th>
                            <th scope="col">thumbnail</th>
                            <th scope="col">Name</th>

                            <th scope="col">Content</th>
                            <th scope="col">Status</th>
                            <th scope="col">Created</th>

                            <th scope="col">Action</th>
                          </tr>
                        </thead>
                        <tbody>
                          {banner?.map((item, index) => (
                            <tr key={index}>
                              <td className="align-center">{index + 1}</td>
                              <td className="align-center">
                                {item?.Image && (
                                  <img
                                    src={`${Image_URL}${item?.Image}`}
                                    alt="Slider Image"
                                    height="100"
                                    width="100"
                                  />
                                )}
                              </td>

                              <td className="align-center">{item?.name}</td>
                              <td className="align-center">{item?.content}</td>
                              <td>
                                <span
                                  className={`badge ${
                                    item &&
                                    item.Status &&
                                    item.Status.toString() === "true"
                                      ? "badge-primary"
                                      : "badge-danger"
                                  }`}
                                >
                                  {item &&
                                  item.Status &&
                                  item.Status.toString() === "true"
                                    ? "Active"
                                    : "Inactive"}
                                </span>
                              </td>

                              <td className="align-center">
                                <p className="mb-0">{item.createdBy?.name}</p>
                                <p className="mb-0">
                                  {new Date(item.createdAt).toLocaleDateString(
                                    "en-US",
                                    {
                                      day: "numeric",
                                      month: "long",
                                      year: "numeric",
                                    }
                                  )}
                                </p>
                              </td>
                              <td className="align-center">
                                <div className="btn-group">
                                  <button
                                    className="btn btn-primary btn-sm"
                                    onClick={() => {
                                      setSelectedItem(item);
                                      setSelectedFile(null);
                                      setHeading(item?.name);
                                      setcontent(item?.content);
                                      setSelectedStatus(
                                        item?.Status ? "1" : "0"
                                      );
                                      setSelectedFile(item?.Image);
                                      setImagePreview(Image_URL + item.Image);

                                      setShowModal(true);
                                    }}
                                  >
                                    <i className="fa fa-edit"></i>
                                  </button>
                                  <button
                                    className="btn btn-danger btn-sm"
                                    onClick={() => DeleteVideoShort(item._id)}
                                  >
                                    <i className="fa fa-trash"></i>
                                  </button>
                                </div>
                              </td>
                            </tr>
                          ))}
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* All Modals */}
      <div
        className={`modal fade ${showModal ? "show" : ""}`}
        id="addHeroSliderModal"
        tabIndex="-1"
        role="dialog"
        style={{ display: showModal ? "block" : "none" }}
      >
        <div
          className="modal-dialog  modal-dialog-centered modal-lg"
          role="document"
        >
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title" id="exampleModalLongTitle">
                Testimonial
              </h5>
              <button
                type="button"
                className="close"
                onClick={() => setShowModal(false)}
                aria-label="Close"
              >
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div className="modal-body">
              <form onSubmit={AddVideoShort}>
                <div className="row">
                  <div className="col-lg-6">
                    <div className="form-group">
                      <label className="mb-0">Image</label>
                      <input
                        type="file"
                        className="form-control"
                        accept="image/*"
                        onChange={handleFileInputChange}
                      />
                    </div>
                  </div>

                  <div className="col-lg-6">
                    <div className="form-group">
                      <label className="mb-0">Heading</label>
                      <input
                        type="text"
                        id="inputgroupName"
                        className="form-control"
                        placeholder="Heading"
                        value={Heading}
                        onChange={(e) => setHeading(e.target.value)}
                      />
                    </div>
                  </div>
                  <div className="col-lg-6">
                    <div className="form-group">
                      <label className="mb-0">Content</label>
                      <input
                        type="text"
                        id="inputgroupName"
                        className="form-control"
                        placeholder="Content"
                        value={content}
                        onChange={(e) => setcontent(e.target.value)}
                      />
                    </div>
                  </div>
                  <div className="col-lg-4">
                    <div className="form-group">
                      <label className="mb-0">Status</label>
                      <select
                        className="form-control"
                        value={selectedStatus}
                        onChange={(e) => setSelectedStatus(e.target.value)}
                      >
                        <option value="">Select</option>
                        <option value="1">Active</option>
                        <option value="0">Inactive</option>
                      </select>
                    </div>
                  </div>

                  {imagePreview && (
                    <div className="col-lg-12">
                      <img
                        width="80"
                        height="50"
                        src={imagePreview}
                        alt="Preview"
                        style={{ maxWidth: "100%" }}
                      />
                    </div>
                  )}
                </div>
                <hr className="mt-0" />

                <div className="row">
                  <div className="col-lg-12">
                    <div className="form-group text-left">
                      <button type="submit" className="btn btn-primary">
                        {selectedItem._id ? "Update" : "Submit"}
                      </button>
                    </div>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
      {showModal && <div className="modal-backdrop fade show"></div>}
    </>
  );
}

export default Testimonial;
